import { action, observable, toJS } from 'mobx';
import ReleasIncidentAPI from '../services/release-incident-service';
import { AppConstants, Types } from '../../../common/APIConstants';
import moment from 'moment';
import _ from 'lodash';
import RestEndPoint from '../../../common/RestEndPoint';
class ReleaseIncidentDataStore {
  @observable dateSelection = {
    estimatedLeakStart:'',
    leakDetectionTime:'',
    approvedOn:''
  };

  @observable screenRowData = {
    ReleaseIncidentData: []
  };
  @observable screenColumnDefinitions = {
    ReleaseIncidentTemplate:[]
  };
  @observable headerDetails = {

    eventDpDwnList: [],
    divisionDpDwnList:[],
    locationDpDwnList:[],
    districtDpDwnList:[]
  };
  @observable hasScreenData = false;

  getGetEventYear = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      let requestObj = {
          
        "division":null,
        "location": null,        
      };
    const { data } = await ReleasIncidentAPI.getFilterData(requestObj);
    this.headerDetails.eventDpDwnList= data; 
    
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
  }
}

  getGetDivsion = async (eventYearTxt,CommonStore) => {
    CommonStore.toggleLoader();
    try {
      let requestObj = {
        "eventYear" :eventYearTxt,
        "division":null,
        "district": null,        
      };
      if (eventYearTxt !== "")
      {
        const { data } = await ReleasIncidentAPI.getFilterData(requestObj);
        this.headerDetails.divisionDpDwnList=[];
        this.headerDetails.districtDpDwnList=[];
        this.headerDetails.locationDpDwnList=[];
        this.headerDetails.divisionDpDwnList= data;    
        
      }
      else
      {
        this.headerDetails.divisionDpDwnList=[];
        this.headerDetails.districtDpDwnList=[];
        this.headerDetails.locationDpDwnList=[];
      }
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
  }
}
getGetDistrict = async (eventYearTxt,divisionTxt,CommonStore) => {
  CommonStore.toggleLoader();
  try {
    let requestObj = {
      "eventYear" :eventYearTxt,
      "division":divisionTxt,
      "district": null,        
    };
   if (divisionTxt !=="" ) 
   {
    const { data } = await ReleasIncidentAPI.getFilterData(requestObj);
    this.headerDetails.districtDpDwnList=[];
    this.headerDetails.locationDpDwnList=[];
    this.headerDetails.districtDpDwnList= data; 
    
   }
  else
  {
    this.headerDetails.districtDpDwnList=[];
    this.headerDetails.locationDpDwnList=[];
  }
  CommonStore.toggleLoader();
} catch (error) {
  CommonStore.toggleLoader();
}
}

getGetLocation = async (eventYearTxt,divisionTxt,districtTxt,CommonStore) => {
  CommonStore.toggleLoader();
  try {
    let requestObj = {
      "eventYear" :eventYearTxt, 
      "division":divisionTxt,
      "district": districtTxt,        
    };
    if (districtTxt !=="")
    {
      const { data } = await ReleasIncidentAPI.getFilterData(requestObj);
      this.headerDetails.locationDpDwnList=[];
      this.headerDetails.locationDpDwnList= data; 
      
    }
    else
    {
      this.headerDetails.locationDpDwnList=[];
    }
  CommonStore.toggleLoader();
} catch (error) {
  CommonStore.toggleLoader();
}
}

saveScreenData = async (currentScreenChildren, CommonStore) => {
  CommonStore.toggleLoader();
  let rowData= this.screenRowData.VendorData.map(v => ({...v, IsModified: v.IsModified?v.IsModified:false}));
  rowData= rowData.filter(x=>x.IsModified);
  var currentTime = moment(new Date());
  try {
    let requestObj = {
      "ScreenDetails": currentScreenChildren[0],     
      "VendorRequests":rowData,
      "UpdatedBy": RestEndPoint.getCurrentUserName(),
      "UpdatedOn":currentTime,
    };
    const { data } = await ReleasIncidentAPI.updateVendorScreenData(requestObj);
    window.toastr.success("Data Saved Sucessfully!");
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
    if (error.response && error.response.data.includes("Data not available for selected date")) {
      window.toastr.error(error.response.data);
    }
    else {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  }
};


resetReleaseIncidentData =() =>
{
  this.screenRowData.ReleaseIncidentData = [];
  this.hasScreenData = false;
}
getScreenData = async (currentScreenChildren, eventYearTxt, divisionTxt,districtTxt, locationTxt, CommonStore) => {
  CommonStore.toggleLoader();
  this.hasScreenData = false;
  this.screenRowData.ReleaseIncidentData=[];
  try {
    let requestObj = {
      "ScreenDetails": currentScreenChildren[0],
      "eventYear": eventYearTxt,
      "division": divisionTxt,
      "district":districtTxt,
      "location": locationTxt
    };
    const { data } = await ReleasIncidentAPI.getScreenData(requestObj);
    this.screenRowData.ReleaseIncidentData = data;
    this.hasScreenData = true;
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
    if (error.response && error.response.data.includes("Data not available for selected date")) {
      window.toastr.error(error.response.data);
    }
    else {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  }
};
uploadIncidentFile = async (data,CommonStore) => {
  CommonStore.toggleLoader();
  try {
   
    await ReleasIncidentAPI.uploadIncidentFiles(data);
    window.toastr.success(AppConstants.TOASTER_SUCCESS);
    CommonStore.toggleLoader();
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};

releaseIncidentDownload = (id,data)=>{
  return ReleasIncidentAPI.releaseIncidentDownload(id,data);
}

releaseIncidentExcelDownload = (data)=>{
  return ReleasIncidentAPI.releaseIncidentExcelDownload(data);
}

getIncidentFiles = async (data,CommonStore) => {
  CommonStore.toggleLoader();
  try {
   
   let returnData= await ReleasIncidentAPI.getIncidentFiles(data);       
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};

GetIncidentByEvent = async (data,CommonStore) => {
  CommonStore.toggleLoader();
  try {
    let returnData= await ReleasIncidentAPI.GetIncidentByEvent(data);       
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};

/**
 * Form submission start 
 *  @param {boolean} dataHasNotBeenChanged - false indicates that form has been modified
*/
leakFormSubmit = async (data,CommonStore,submitType, lastUpdateBy, dataHasNotBeenChanged) => {
  const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN');
  const roleObj = JSON.parse(jsonStringOBJ);
  const { displayName } = roleObj;

  data['estimatedLeakStart'] = typeof this.dateSelection.estimatedLeakStart!='undefined' && this.dateSelection.estimatedLeakStart!='' && (moment(this.dateSelection.estimatedLeakStart).format('YYYY-MM-DD HH:mm:ss'))!='Invalid date'?(moment(this.dateSelection.estimatedLeakStart).format('YYYY-MM-DD HH:mm:ss')):'';
  data['leakDetectionTime'] = typeof this.dateSelection.leakDetectionTime!='undefined' && this.dateSelection.leakDetectionTime!='' && (moment(this.dateSelection.leakDetectionTime).format('YYYY-MM-DD HH:mm:ss'))!='Invalid date'?(moment(this.dateSelection.leakDetectionTime).format('YYYY-MM-DD HH:mm:ss')):'';
  data['approvedOn'] = typeof this.dateSelection.approvedOn!='undefined' && this.dateSelection.approvedOn!='' && (moment(this.dateSelection.approvedOn).format('YYYY-MM-DD HH:mm:ss'))!='Invalid date'?(moment(this.dateSelection.approvedOn).format('YYYY-MM-DD HH:mm:ss')):'';

  if(submitType === 1 || 
    submitType === 2 || 
    (submitType === 3 && !lastUpdateBy) || 
    (dataHasNotBeenChanged === false && roleObj?.roles.includes("ReleaseIncidentReadWrite"))
  ){
    data['lastUpdateBy'] = displayName;
  }

  CommonStore.toggleLoader();
  try {
   
   let returnData= await ReleasIncidentAPI.saveLeakDetectionResponseForm(data);       
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};
/* Form submission end */

/* Update LDS Status API */
LeakDetectionStatusUpdate = async (data,CommonStore,submitType,values,event_id,singleGridData) => {
  CommonStore.toggleLoader();
  try {
    let returnData = [];
    if(submitType!=3 || submitType!=4)
      returnData =  await ReleasIncidentAPI.LeakDetectionStatusUpdate(data);       
    
    /* */
    if(submitType==2 && returnData){
      let mailContent = {
        "emailTemplate": null,
        "eventId": event_id,
        "title": singleGridData.title,
        "division": singleGridData.division,
        "district": singleGridData.district,
        //"location": values.leakLocation,
        "eventDate": singleGridData.incidentDate!='' && typeof singleGridData.incidentDate!='undefined'?moment(singleGridData.incidentDate).format('MMM DD, YYYY HH:mm a'):''
      }
      // Send mail API 
      let sendApiCall = await this.sendMailApi(mailContent, CommonStore);
      
      if(sendApiCall){
        // FORM SUBMIT SUCCESS 
        window.toastr.success("Data Saved Sucessfully!");
      }

    }
    else if(submitType==3 || submitType==4){
      const jsonStringOBJ = sessionStorage.getItem('AUTH_TOKEN');
      const roleObj = JSON.parse(jsonStringOBJ);
      const { displayName } = roleObj;
      //Approve or reject
      let approveParameter = {
        "ReviewApprovedBy": displayName,
        "TicketId": event_id,
        "ApprovedOn": moment().format('YYYY-MM-DD HH:mm:ss')
    }
      //let approveReject = await this.approveRejectApi(approveParameter, CommonStore);
      let msg = submitType==3?'Approve is updated sucessfully!':'Reject is updated sucessfully!';
      //if(approveReject){
        window.toastr.success(msg);
      //}
    }
    else{
      // FORM SUBMIT SUCCESS 
      window.toastr.success("Data Saved Sucessfully!");
    }


    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
     console.log('error');
     console.log(error);
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};
/* Send MAIL API */
sendMailApi = async (data,CommonStore) => {
  CommonStore.toggleLoader();
  try {
    let returnData= await ReleasIncidentAPI.sendMailApi(data);       
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};

/* Approve reject update */
approveRejectApi = async (data,CommonStore) => {
  CommonStore.toggleLoader();
  try {
    let returnData= await ReleasIncidentAPI.UpdateApprovedByReleaseIncident(data);       
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};

getApproverAPI = async (CommonStore) => {
  CommonStore.toggleLoader();
  try {
    let returnData= await ReleasIncidentAPI.GetApproversReleaseIncident();       
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    CommonStore.toggleLoader();
    window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
  }
};


@action
estimatedLeakStartUpdate = (dt)=>{
  this.dateSelection.estimatedLeakStart = dt;
}

@action
leakDetectionTimeUpdate = (dt)=>{
  this.dateSelection.leakDetectionTime = dt;
}

@action
approvedOnUpdate = (dt)=>{
  this.dateSelection.approvedOn = dt;
}


getLeakDetections = async (data,CommonStore) => {
  CommonStore.toggleLoader();
  try {
   
   let returnData= await ReleasIncidentAPI.getLeakDetections(data);   
   
   /* LEAK DETECTION DATE */
   this.dateSelection.estimatedLeakStart = returnData.data.estimatedLeakStart;
   this.dateSelection.leakDetectionTime = returnData.data.leakDetectionTime; 
   this.dateSelection.approvedOn = returnData.data.approvedOn; 

   returnData['frontstatus'] = true;
    CommonStore.toggleLoader();
    return returnData;
  }
  catch (error) {
    let returnData = [];
    returnData['frontstatus'] = false;
    returnData['message'] = error;
    //console.log('error',error);
    CommonStore.toggleLoader();
    //window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    return returnData;
  }
};
setColumnDef = async (currentScreenChildren, CommonStore,popupHandler,leakDetectionHandler) => {
  CommonStore.toggleLoader();
  try {
    currentScreenChildren.forEach((child) => {
      const { screen, screenColumns: columns } = child;
      this.screenColumnDefinitions[child.screen.name] = [];
      this.screenColumnDefinitions[child.screen.name] = this.getAllColumnDefinitions(screen, 
        columns,popupHandler,leakDetectionHandler
      );
    });
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
    if (error.response && error.response.data.includes("Data not available for selected date")) {
      window.toastr.error(error.response.data);
    }
    else {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  }
};

  getAllColumnDefinitions = (screen, columns,popupHandler,leakDetectionHandler) => {
    const gridColumns = [];
    columns.forEach((column) => {
          gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: 'text',
        hide: column.hidden,
        width: column.width ? column.width : 200,
        pinned: ( (column.name=='ticketId') || (column.name=='ticketUId') || (column.name=='status') || (column.name=='Upload') || (column.name=='Upload') ?'left':''),
        lockPinned: ( (column.name=='ticketId') || (column.name=='ticketUId') || (column.name=='status') || (column.name=='Upload') || (column.name=='Upload') ?true:false),
        cellClass:( (column.name=='ticketId') || (column.name=='ticketUId') || (column.name=='status') || (column.name=='Upload') || (column.name=='Upload') ?true:false),
        keyCreator: (params) => { return this.getValueFomatter(params, column, screen) ? this.getValueFomatter(params, column, screen) : params.value },
        editable: (params) => { return this.getIsEditable(params, column, screen) },
        cellClassRules: {
          'highlight-cell': (params) => { return this.getIsEditable(params, column, screen) },
          'grid-cell-custom': (params) => { return params.data ? true : false }
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) => this.getCellRendererParams(column, params,popupHandler,leakDetectionHandler),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => { return this.getValueFomatter(params, column, screen) },
      });
     
    });
    return gridColumns;
  };
 
  getValue(params,screen, column )
  {  
   
    return params.data[column.name];  
  }
  getIsEditable(params, column, screen) {
    
    if (this.getIsDataReadOnly() || !params.data)
      return false;

    // if (screen.name === "Production" && column.name === "TargetValue" && params.node.data.Parameter === "Upgrader Fd") {
    //   return true;
    // }
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {

    /* Uncomment any of this to disable the editing on screen for past dates OR a week before */
    
    // return moment(this.headerDetails.endDateTime).isBefore(moment(), "day");
    // return moment(this.headerDetails.endDateTime).isBefore(moment().subtract(7, "days"), "day");

    return false;
  }

  getCellRenderer(column) {
    if(column.rowKey=="TicketUId")
    return 'statusButtonRenderer';  
    if(column.rowKey=="Upload")
    return 'uploadButtonRenderer';  
    if(column.rowKey=="TicketId")
    return 'eventHyperlinkRenderer';  
    switch (column.type) {
      case Types.BOOLEAN:
        return 'booleanCellEditor';
      case Types.DATE:
        return 'dateFormatter';
        case Types.DATETIME:
        return 'dateTimeFormatter';
       
    }
  }

  getCellEditor(column) {
   
    switch (column.type) {
      case Types.DROPDOWN:
        return 'SmartSelectClearable';
        case Types.NUMBER:
          return 'numericCellEditor';
          case Types.DECIMAL:
          return 'decimalCellEditor';
    }
  }
  getCellEditorParams(column, params) {

    switch (column.type) {
      case Types.DROPDOWN:
        return {values: column.refLookupData?.lookupValues.values, isPopup: true};
    }
  }

  getCellRendererParams(column, params,handler,leakDetectionHandler) {
   if(column.rowKey=="Upload")
    return { clicked:handler};
  if(column.rowKey=="TicketUId")
   return { showLeakDetection:leakDetectionHandler};
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(column.refLookupData.lookupValues, params.value);
      }

      // if (screen.name === "ProductSpec" && (column.name === "DailyAvgValue" || column.name === "InstantValue")) {
      //   return (params.node.data.Parameter === "C3 Treater Moisture" && params.value == "99") ? "Bypassed" : params.value;
      // }
    }
  }

  lookupValue(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value == key)) return null;
    else {
      let label = mappings.values.find(item => item.value == key).label;
      return label;
    }
  }
}

export default new ReleaseIncidentDataStore();